import React, { Component } from 'react';

import FormSettings from '../../shared/constants/form-settings';
import FormActions from '../../shared/actions/form';

import { coalesce } from '../../shared/utilities';

export default class SettingsTab extends Component {
	static propTypes = {
		
	}

	constructor (props) {
		super(props);
	}
	
	render () {
		return null;
	};
	
	coalesceProperty = (property, fallback = false) => {
		return coalesce(this.props.formData.settings, property, fallback);
	}
	
	removeScheduleObject = () => {
		FormActions.removeSettingsKey(FormSettings.SCHEDULE)
	}
	
	updateSetting = (key, value) => {
		FormActions.saveSetting(key, value);
	}
}



// WEBPACK FOOTER //
// ./src/main/webapps/features/form-builder/react/advanced-settings/components/tab.js